export interface IPushNotificationSettings {
  id: string;
  name: string;
  publishType: EPushNoticationPublishType;
  teamId: string;
  notificationCertificate: string;
  configIds?: string[];
}

export enum EPushNoticationPublishType {
  Development = 0,
  Production = 1
}
